import { api, externalApis } from '../../services';
import { ACTION_TYPES } from '../../constants';

export const getAiKey = () => {
  return async (dispatch) => {
    const aiKey = await api.getAiKey();
    dispatch({
      type: ACTION_TYPES.SET_AI_KEY,
      payload: aiKey.apiKey,
    });
  };
};

export const getMapKey = () => {
  return async (dispatch) => {
    const mapKey = await api.getMapKey();
    dispatch({
      type: ACTION_TYPES.SET_MAP_KEY,
      payload: mapKey.apiKey,
    });
  };
};

export const getWeatherKey = () => {
  return async (dispatch) => {
    const weatherKey = await api.getWeatherKey();
    dispatch({
      type: ACTION_TYPES.SET_WEATHER_KEY,
      payload: weatherKey.apiKey,
    });
  };
};

export const getCurrentWeather = () => {
  return async (dispatch, getState) => {
    const { currentCoords } = getState().selections;
    const { weatherKey } = getState().data;
    const currentWeather = await externalApis.getCurrentWeather(currentCoords, weatherKey);
    dispatch({
      type: ACTION_TYPES.SET_CURR_WEATHER,
      payload: currentWeather,
    });
  };
};
